// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Br-z","imageAndVideoCount":"Cr-z","imageAndVideoContainer":"Dr-z","viewAllReviews":"Er-z"};